export default {
  namespaced: true,
  chat: {
    error: "You doesn't have an user for chat",
    new_message: "New message from {user}",
    new_emergency_chat: "New Emergency Chat",
    emergency_groups: "Chats Emergency",
    group_name: "Group name",
    users: "Users",
    chats: "Chats",
    contacts: "Contacts",
    chats_group: "Chats Group",
    start_conversation: "Start Conversation",
    send: "Send",
    eliminated : "Eliminated",
    added : "Added",
    no_room_found_text: "No room found",
    end_chat: "End chat",
    chat_has_ended: "Chat ended",
    finalized: "Finalized",
    assigned: "Assigned",
    all: "All",
  }
}
